import React, { FC } from 'react';
import './styles.scss';

const HOURS24_URL = 'https://hours24.com/en';

/**
 * Sponsored hours24 promo banner shown at the top of the employer web shell.
 */
export const Hours24Banner: FC = () => {
  return (
    <a className="hours24-banner" href={HOURS24_URL} target="_blank" rel="noopener noreferrer">
      <span className="hours24-banner__sponsored">Sponsored</span>

      <div className="hours24-banner__brand">
        <span className="hours24-banner__logo" aria-hidden="true">
          <svg width="44" height="44" viewBox="44 68 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M104 98C104 114.569 90.5685 128 74 128C57.4315 128 44 114.569 44 98C44 81.4315 57.4315 68 74 68C90.5685 68 104 81.4315 104 98ZM57.7796 98C57.7796 106.958 65.0417 114.22 74 114.22C82.9583 114.22 90.2204 106.958 90.2204 98C90.2204 89.0417 82.9583 81.7796 74 81.7796C65.0417 81.7796 57.7796 89.0417 57.7796 98Z"
              fill="#172271"
            />
            <rect
              x="69.7117"
              y="96.4268"
              width="24.0092"
              height="8.57143"
              rx="4.28572"
              transform="rotate(-45 69.7117 96.4268)"
              fill="#172271"
            />
          </svg>
        </span>

        <span className="hours24-banner__brand-text">
          <span className="hours24-banner__brand-name">hours24</span>
          <span className="hours24-banner__brand-tagline">AI WORKFORCE ADMIN</span>
        </span>
      </div>

      <span className="hours24-banner__divider" />

      <div className="hours24-banner__copy">
        <h4 className="hours24-banner__title">
          New hire, locked in.
          <br />
          Let hours24 handle the paperwork and HR admin.
        </h4>
        <p className="hours24-banner__subtitle">
          Time tracking, vacations &amp; HR in one place - free for up to 5 employees.
        </p>
      </div>

      <span className="hours24-banner__cta">Try hours24.com</span>
    </a>
  );
};
